export enum VehicleTypeEnum {
  CAR = 'CAR',
  MOTORCYCLE = 'MOTORCYCLE',
  QUAD = 'QUAD',
}
